<template>
  <div>
    <Banner />
    <RankingView />
    <ProgramsView />
    <WhyyouView />
    <CollaborationsView />
    <ItalladdsView />
    <CertificateVue />
    <HiringPartnerVue />
    <OurAlumnaiVue />
    <AdmissionView />
    <DestinationView />
    <!-- <ChatBotView /> -->
  </div>
</template>

<script>
import RankingView from "../components/LPnew/RankingView.vue";
import ProgramsView from "../components/LPnew/ProgramsView.vue";
import WhyyouView from "../components/LPnew/WhyyouView.vue";
import CollaborationsView from "../components/LPnew/CollaborationsView.vue";
import ItalladdsView from "../components/LPnew/ItalladdsView.vue";
import CertificateVue from "@/components/LPnew/Certificate.vue";
import HiringPartnerVue from "@/components/LPnew/HiringPartner.vue";
import OurAlumnaiVue from "@/components/LPnew/OurAlumnai.vue";
import AdmissionView from "../components/LPnew/AdmissionView.vue";
import DestinationView from "../components/LPnew/DestinationView.vue";
import Banner from "../components/LpnewThankyou/Banner.vue";
// import ChatBotView from "@/components/ChatBot.vue";
export default {
  components: {
    Banner,
    RankingView,
    ProgramsView,
    WhyyouView,
    CollaborationsView,
    ItalladdsView,
    CertificateVue,
    HiringPartnerVue,
    OurAlumnaiVue,
    AdmissionView,
    DestinationView,
    // ChatBotView,
  },
  // beforeRouteEnter(to, from, next) {
  //   next((vm) => {
  //     // Redirect to the final URL after 4 seconds
  //     setTimeout(() => {
  //       window.location.href =
  //         "https://apply.onlinejain.com/all-application-form";
  //     }, 4000); // Adjust the delay as needed
  //   });
  // },
};
</script>

<style scoped></style>
